/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index filter to autogenerate all the components and extensions
 * Used by "prepareFilters"
 */

import Filter from './filter/Filter'
export * from './filter/Filter'
export default Filter
